import { z } from 'zod';
import { nonEmptyString, uuidSchema } from './common.js';
// ============================================================
// Widget Config Schemas (discriminated union on `type`)
// ============================================================
const gridSizeSchema = z.object({
    xs: z.number().int().min(1).max(12),
    sm: z.number().int().min(1).max(12),
    md: z.number().int().min(1).max(12),
    lg: z.number().int().min(1).max(12),
});
const tableColumnSchema = z.object({
    key: nonEmptyString,
    labelKey: nonEmptyString,
    format: z.enum(['text', 'date', 'number', 'status', 'percent']).optional(),
    width: z.number().optional(),
});
const statWidgetConfigSchema = z.object({
    type: z.literal('stat'),
    dataSource: nonEmptyString,
    valueKey: nonEmptyString,
    icon: nonEmptyString,
    color: nonEmptyString,
    trendKey: z.string().optional(),
    linkTo: z.string().optional(),
    label: nonEmptyString,
});
const chartWidgetConfigSchema = z.object({
    type: z.literal('chart'),
    chartType: z.enum(['bar', 'line', 'pie', 'area', 'donut']),
    dataSource: nonEmptyString,
    dataKey: nonEmptyString,
    xAxisKey: z.string().optional(),
    yAxisKey: z.string().optional(),
    colors: z.array(z.string()).optional(),
    showLegend: z.boolean().optional(),
    label: nonEmptyString,
});
const tableWidgetConfigSchema = z.object({
    type: z.literal('table'),
    dataSource: nonEmptyString,
    columns: z.array(tableColumnSchema).min(1),
    maxRows: z.number().int().min(1).optional(),
    linkTo: z.string().optional(),
    sortBy: z.string().optional(),
    label: nonEmptyString,
});
const actionWidgetConfigSchema = z.object({
    type: z.literal('action'),
    actionType: z.enum(['absence_approval', 'booking_approval', 'ticket_assign']),
    dataSource: nonEmptyString,
    maxItems: z.number().int().min(1).optional(),
    label: nonEmptyString,
});
const listWidgetConfigSchema = z.object({
    type: z.literal('list'),
    dataSource: nonEmptyString,
    dataKey: nonEmptyString,
    titleKey: nonEmptyString,
    subtitleKey: z.string().optional(),
    maxItems: z.number().int().min(1).optional(),
    linkTo: z.string().optional(),
    badgeKey: z.string().optional(),
    label: nonEmptyString,
});
export const widgetConfigSchema = z.discriminatedUnion('type', [
    statWidgetConfigSchema,
    chartWidgetConfigSchema,
    tableWidgetConfigSchema,
    actionWidgetConfigSchema,
    listWidgetConfigSchema,
]);
export const dashboardWidgetSchema = z.object({
    id: nonEmptyString,
    config: widgetConfigSchema,
    gridSize: gridSizeSchema,
    permissions: z.array(z.string()),
    order: z.number().int().min(0),
});
// ============================================================
// Preset Schemas
// ============================================================
export const createPresetSchema = z.object({
    name: nonEmptyString.max(200),
    description: z.string().max(500).nullable().optional(),
    visible_roles: z.array(z.string()),
    widgets: z.array(dashboardWidgetSchema).min(1),
    is_shared: z.boolean().optional().default(false),
    icon: z.string().nullable().optional(),
});
export const updatePresetSchema = createPresetSchema.partial();
export const updateUserPreferenceSchema = z.object({
    active_preset_id: uuidSchema.nullable().optional(),
    pinned_preset_ids: z.array(uuidSchema).optional(),
});
//# sourceMappingURL=dashboard.js.map